import React, { Component, Fragment } from 'react'
import { STEP_TYPES } from '../constants'
import { pathOr } from 'ramda'
import PropTypes from 'prop-types'
import DemoRequestStep from '../component'
import BotPreview from 'components/OnboardingBotPreview'


const STEP_OBJECT = Object.freeze(STEP_TYPES.INDUSTRY)
class IndustryStep extends Component {

  static propTypes = {
    index: PropTypes.number.isRequired,
    stepCount: PropTypes.number.isRequired,
    onContinue: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      industry: '', //TODO: prefill from clearbit
      previewInputValue: STEP_OBJECT.previewTextDefault,
    }
  }

  handleInputChange = (event) => {
    const { previewTextDefault } = STEP_OBJECT
    const changedValue = pathOr('', ['target', 'value'], event)
    const previewChangedValue = !!changedValue ? changedValue : previewTextDefault
    this.setState({ industry: changedValue, previewInputValue: previewChangedValue })
  }

  handleIndustrySave = () => {
    const { actions } = this.props
    const { industry } = this.state
    actions.setIndustry(industry)
  }

  render() {
    const { productName, valueProp } = this.props
    const { industry, previewInputValue } = this.state
    const botPreview = <BotPreview productName={productName} valueProp={valueProp} industry={previewInputValue} tipPosition={STEP_OBJECT.tipPosition} tipText={STEP_OBJECT.tipText} arrowSource={STEP_OBJECT.arrowSource} />
    return (
      <Fragment>
        <DemoRequestStep stepObject={STEP_OBJECT} botPreview={botPreview} inputValue={industry} handleSave={this.handleIndustrySave} handleInputChange={this.handleInputChange} {...this.props} />
      </Fragment>
    )
  }
}

export default IndustryStep



// WEBPACK FOOTER //
// ./src/layouts/OnboardingPlaybookDemoRequestStep/IndustryStep/index.js